module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NTAiIGhlaWdodD0iMzAwIiB2aWV3Qm94PSIwIDAgMTUgMTAiPjxwYXRoIGZpbGw9IiNFODExMkQiIGQ9Ik0wIDBoMTV2MTBIMHoiLz48cGF0aCBmaWxsPSIjRkNEMTE2IiBkPSJNMCAwaDE1djVIMHoiLz48cGF0aCBmaWxsPSIjMDA4NzUxIiBkPSJNMCAwaDZ2MTBIMHoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/ben.svg
// module id = 7eUX
// module chunks = 0